import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const NationalCases = lazy(() => import('./NationalCases.jsx'))
const SingleNationalInbox = lazy(() => import('./SingleNationalInbox.jsx'))

const NationalCaseRoutes = [
    {
        path: '/NationalCases',
        component: NationalCases,
        auth: authRoleAccess.national_case,
    },

    {
        path: '/SingleNationalInbox/:id',
        component: SingleNationalInbox,
        auth: authRoleAccess.national_case,
    },

]

export default NationalCaseRoutes 